export default "<div [innerHTML]=\"licenseText\"></div>\n";